import { createContext, Dispatch } from "react";
import {
  DEFAULT_VISITOR_CONTEXT,
  TVisitorContext,
} from "src/trackers/viewerContext";

import { PublicationShortname } from "./auth/serviceIdentifier";
import { TAction } from "./reducer";

export type TAppContext = {
  pubId: PublicationShortname;
  issueId?: number;
  visitorContext: TVisitorContext | null;
  // True once the viewerContext fetch has resolved at least once. Distinguishes
  // the initial anonymous-looking DEFAULT_VISITOR_CONTEXT from a confirmed
  // anonymous result, so the preview CTA doesn't flash before entitlement is
  // known (EPPR2-3142).
  viewerContextResolved: boolean;
  dispatch: Dispatch<TAction>;
};

const defaultInitialState: TAppContext = {
  pubId: PublicationShortname.DEFAULT,
  issueId: undefined,
  visitorContext: DEFAULT_VISITOR_CONTEXT,
  viewerContextResolved: false,
  dispatch: () => null,
};

export function getInitialState(): TAppContext {
  return defaultInitialState;
}

const AppContext = createContext<TAppContext>(getInitialState());

export default AppContext;
